import React from "react";

export default function CarouselItem(props:any) {
    const { imgUrl, imgTitle } = props
    return (
        <div className="carousel-card">
        <img src={imgUrl} alt={imgTitle}></img>
        </div>
    );
}